import { createAction, props } from '@ngrx/store';
import { ApplicationUserDetail } from '../../models/application-user-detail.model';
import { IdNameMap } from '../../models/id-name-map.model';
import { TeamMap } from '../../models/team-map.model';

export const loadActiveBusinessUnitsSuccess = createAction(
    '[User Management API] Load Active Business Units Success',
    props<{ allBusinessUnits: IdNameMap[] }>()
);

export const loadActiveBusinessUnitsFailure = createAction(
    '[User Management API] Load Active Business Units Failure',
    props<{ error: string }>()
);

export const loadActiveRolesSuccess = createAction(
    '[User Management API] Load Active Roles Success',
    props<{ allRoles: IdNameMap[] }>()
);

export const loadActiveRolesFailure = createAction(
    '[User Management API] Load Active Roles Failure',
    props<{ error: string }>()
);

export const loadActiveTeamsSuccess = createAction(
    '[User Management API] Load Active Teams Success',
    props<{ allTeams: TeamMap[] }>()
);

export const loadActiveTeamsFailure = createAction(
    '[User Management API] Load Active Teams Failure',
    props<{ error: string }>()
);

export const loadUserDetailSuccess = createAction(
    '[User Management API] Load User Detail Success',
    props<{ userDetail: ApplicationUserDetail }>()
);

export const loadUserDetailFailure = createAction(
    '[User Management API] Load User Detail Failure',
    props<{ error: string }>()
);

export const saveApplicationUserDetailSuccess = createAction(
    '[User Management API] Save Application User Detail Success',
    props<{ userDetail: ApplicationUserDetail }>()
);

export const saveApplicationUserDetailFailure = createAction(
    '[User Management API] Save Application User Detail Failure',
    props<{ error: string }>()
);

export const resetUserSecurityStampSuccess = createAction(
    '[User Management API] Reset User Security Stamp Success',
    props<{ userDetail: ApplicationUserDetail }>()
);

export const resetUserSecurityStampFailure = createAction(
    '[User Management API] Reset User Security Stamp Failure',
    props<{ error: string }>()
);
